import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FacebookIcon from '../../assets/svg/facebook.svg';

import sendEmail from '../../lib/sendEmail';

import ContentBlock from '../../components/ContentBlock/ContentBlock';

import Layout from '../../components/Layout/Layout';
import { getContactPage } from '../../lib/dato';
import Spinner from '../../components/Atoms/Spinner';

const SendMessageSchema = yup.object().shape({
  name: yup.string().required('Naam is verplicht'),
  phone: yup.string(),
  mail: yup.string().email('Ongeldig e-mailadres').required('E-mailadres is verplicht'),
  subject: yup.string().required('Onderwerp is verplicht'),
  message: yup.string().required('Bericht is verplicht'),
});

export default function ContactPage({ contact }) {
  const [sendingError, setSendingError] = useState(false);
  const [sending, setSending] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const { handleSubmit, handleChange, values } = useFormik({
    initialValues: {
      name: '',
      phone: '',
      mail: '',
      subject: '',
      message: '',
    },
    validateOnChange: false,
    validationSchema: SendMessageSchema,
    onSubmit: async values => {
      setSendingError(false);
      setSending(true);
      setIsSend(false);
      try {
        await sendEmail(values);
        setIsSend(true);
      } catch (error) {
        setSendingError(true);
      } finally {
        setSending(false);
      }
    },
  });

  return (
    <Layout title="Contact">
      <ContentBlock
        fullWidth={false}
        title={contact.title}
        imageData={contact.descriptionimage?.responsiveImage}
        content={
          <>
            <p>
              <span>Tel:</span> <a href={`tel:${contact.phone}`}>{contact.phone}</a>
            </p>
            <p>
              <span>E-mail:</span> <a href={`mailto:${contact.mail}`}>{contact.mail}</a>
            </p>
            <p>
              <span>BTW: </span> {contact.btw}
            </p>
            <p className="Facebook">
              <a target="_blank" href={contact.facebookUrl} rel="noreferrer">
                <FacebookIcon /> Agravla
              </a>
            </p>
          </>
        }
      />

      <div className="formContainer">
        <h2>Contactformulier</h2>
        {sending ? <Spinner /> : null}
        <form className="form" onSubmit={handleSubmit}>
          {isSend && !sending && (
            <p className="formSuccessMessage">
              Je vraag is succesvol verzonden. We reageren zo snel mogelijk. Heb je een dringende
              vraag? Neem dan telefonisch contact op via{' '}
              <a href={`tel:${contact.phone}`}>{contact.phone}</a>.
            </p>
          )}
          {sendingError ? (
            <p className="formErrorMessage">
              Er is een probleem bij het versturen van je vraag, probeer opnieuw of stuur je vraag
              naar <a href={`mailto:${contact.mail}`}>{contact.mail}</a>
            </p>
          ) : null}
          {((!isSend && !sending) || sendingError) && (
            <>
              <input
                id="name"
                name="name"
                onChange={handleChange}
                placeholder="Naam"
                required
                type="text"
                value={values.name}
              />
              <div className="inputRow">
                <input
                  id="phone"
                  name="phone"
                  onChange={handleChange}
                  placeholder="Telefoon"
                  type="text"
                  value={values.phone}
                />
                <input
                  id="mail"
                  name="mail"
                  onChange={handleChange}
                  placeholder="E-mail"
                  required
                  type="email"
                  value={values.mail}
                />
              </div>
              <input
                id="subject"
                name="subject"
                onChange={handleChange}
                placeholder="Onderwerp"
                required
                type="text"
                value={values.subject}
              />
              <textarea
                id="message"
                name="message"
                onChange={handleChange}
                placeholder="Bericht"
                required
                value={values.message}
                rows={4}
                cols={50}
              />
              <button type="submit">Verzend</button>
            </>
          )}
        </form>
      </div>
    </Layout>
  );
}

export async function getStaticProps() {
  const contact = await getContactPage();
  return {
    props: { contact },
  };
}
